import { render, staticRenderFns } from "./BrowserWindow.vue?vue&type=template&id=514e7b6e&lang=pug"
var script = {}
import style0 from "./BrowserWindow.vue?vue&type=style&index=0&id=514e7b6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports